/**
 * Texts for User Training page - Dutch
 */
export const userTrainingPageText = {
    title: 'Gebruikerstraining - CamAPS FX',
    titleMeta: 'Uitgebreide trainingsbronnen voor CamAPS FX-gebruikers',
    descriptionMeta: 'Toegang tot volledige trainingsmateriaal, videotutorials, gebruikershandleidingen en webinars om het meeste uit CamAPS FX te halen.',
    keywords:
        'camaps fx gebruikerstraining, camaps training, diabetes training, insulinepomp training, gebruikershandleiding, videotutorials',
    localeMeta: 'nl_nl',

    mainHeader: 'Gebruikerstraining',
    mainSubHeader: 'Voltooi de essentiële in-app training voordat u de CamAPS FX-app gebruikt.',

    gettingStartedHeader: 'Aan de slag',
    step1Title: '<strong>Stap 1:</strong><br/>Download de app',
    step2Title: '<strong>Stap 2:</strong><br/>Maak een account aan',
    step3Title: '<strong>Stap 3:</strong><br/>Begin de essentiële in-app training',
    step4Title: '<strong>Stap 4:</strong><br/>Koppel met uw gekozen pomp en CGM (met goedkeuring van uw zorgteam) of verken de app met <strong>virtuele modus</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Hulp nodig bij het installeren van de app?',
    supportSectionText: 'Bezoek onze supportpagina voor begeleiding',
    supportButtonText: 'ONDERSTEUNING',
    findOutMoreButtonText: 'MEER INFORMATIE',

    additionalResourcesTitle: 'Aanvullende bronnen',
    additionalResourcesSubtitle: 'Leer door middel van stapsgewijze visualisaties of bekijk door experts geleide sessies over het gebruik van de app.',
    
    animationsTitle: 'Animaties',
    animationsDescription: 'De Dana insulinepomp is op dit moment alleen commercieel verkrijgbaar met CamAPS FX in het Verenigd Koninkrijk. Alle bronnen met betrekking tot Dana zijn daarom alleen beschikbaar in het Engels.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webinars',
    webinarsDescription: 'Deze webinars zijn geschikt voor mensen met diabetes type 1, hun familie en verzorgers, maar ook voor docenten, onderwijsondersteunend personeel en zorgprofessionals.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Informatiebladen',
    factsheetsDescription: 'Ontworpen om startgidsen te zijn. Ze vervangen of vervangen niet het medisch advies en de ondersteuning van iemands diabetesteam.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'In-app training',
    inAppTrainingText: 'Begin met de essentiële training die in de CamAPS FX-app is ingebouwd. Deze interactieve training leidt u door alle belangrijke functies die u moet kennen.<br/><br/><strong>Toegang:</strong> Download de CamAPS FX-app en maak een account aan om uw in-app training te beginnen.',

    gettingStartedText: '<strong>Stap 1:</strong> Download de CamAPS FX-app uit de app store van uw apparaat<br/><strong>Stap 2:</strong> Maak uw account aan<br/><strong>Stap 3:</strong> Voltooi de in-app trainingsmodules<br/><strong>Stap 4:</strong> Verbind uw insulinepomp en CGM<br/><strong>Stap 5:</strong> Begin uw CamAPS FX-reis',

    trainingResourcesHeader: 'Extra trainingsbronnen',
    videoTutorialsText: 'Videotutorials',
    videoTutorialsDesc: 'Bekijk stapsgewijze videogidsen over installatie, dagelijks gebruik en probleemoplossing.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Gebruikershandleidingen & Documentatie',
    userGuidesDesc: 'Download uitgebreide PDF-handleidingen en snelle referentiematerialen.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Live webinars',
    webinarsDesc: 'Neem deel aan door experts geleide trainings en Q&A-mogelijkheden.',

    needHelpHeader: 'Hulp nodig?',
    needHelpTextStart: 'Als u hulp nodig heeft of vragen heeft, bezoek onze',
    supportLinkText: 'Support',
    needHelpTextEnd: 'pagina voor aanvullende hulp en contactinformatie.'
};

